import { forwardRef, HTMLAttributes, PropsWithChildren, ReactElement } from 'react'

import { cn } from '@/lib/utils'

export type ButtonMaskProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  children: ReactElement<PropsWithChildren>
}

const ButtonMask = forwardRef<HTMLSpanElement, ButtonMaskProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <span ref={ref} className="flex overflow-hidden" {...props}>
        <span
          data-label={children?.props?.children}
          className={cn(
            'relative inline-flex flex-col',
            'after:inline-flex after:content-[attr(data-label)]',
            'after:font-helvetica after:text-button',
            'after:absolute after:left-0 after:top-0 after:size-full after:translate-y-[120%]',
            'transition-transform duration-500 ease-out-cubic',
            'group-hover/button:-translate-y-[120%]',
            className
          )}
        >
          <span className="inline-flex">{children}</span>
        </span>
      </span>
    )
  }
)

export default ButtonMask
